"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PageTitle(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'ProducePay Insights' : _ref$title,
      description = _ref.description;
  return _react.default.createElement(_reactHelmet.Helmet, null, _react.default.createElement("title", null, title), description ? _react.default.createElement("meta", {
    name: "description",
    content: description
  }) : null);
}

PageTitle.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string
};

var _default = _react.default.memo(PageTitle);

exports.default = _default;